import {forEach} from 'lodash';
import * as types from '../../../actions/actiontypes';
import initialState from '../../initialstate';

export default function BulkRequestSeeRequest(state = initialState.bulkRequestSeeRequest, action) {
	switch (action.type) {
		case types.BULK_REQUEST_ADD_REQUEST_TO_SELECTED_REQUESTS: {
			let tempState = _.cloneDeep(state);
			forEach(action.data, (r) => {
				tempState.set(r.clientRequestID, r);
			});
			return tempState;
		}
		case types.BULK_REQUEST_REMOVE_REQUEST_FROM_SELECTED_REQUESTS: {
			let tempState = _.cloneDeep(state);
			forEach(action.data, (r) => {
				delete tempState.delete(r.clientRequestID);
			});
			return tempState;
		}

		case types.BULK_REQUEST_ADD_ALL_REQUESTS_TO_SELECTED_REQUESTS: {
			let tempState = new Map();
			forEach(action.data, (r) => {
				tempState.set(r.clientRequestID, r);
			});
			return tempState;
		}

		case types.BULK_REQUEST_REMOVE_ALL_REQUESTS_FROM_SELECTED_REQUESTS: {
			return new Map();
		}
		default:
			return state;
	}
}
